import { render, staticRenderFns } from "./RegulationsInformation.vue?vue&type=template&id=83b21566&scoped=true"
import script from "./RegulationsInformation.vue?vue&type=script&lang=js"
export * from "./RegulationsInformation.vue?vue&type=script&lang=js"
import style0 from "./RegulationsInformation.vue?vue&type=style&index=0&id=83b21566&prod&lang=stylus&scoped=true"
import style1 from "./RegulationsInformation.vue?vue&type=style&index=1&id=83b21566&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b21566",
  null
  
)

export default component.exports